import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class FeatureSection {
	constructor() {
		this.sections = document.querySelectorAll("[data-feature-section]");
	}

	init() {
		this.sections.forEach((section) => {
			this._setupParallax(section);
			this._syncSquiggle(section);
		});

		let resizeTimer;
		window.addEventListener("resize", () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				this.sections.forEach((section) => this._syncSquiggle(section));
			}, 100);
		});
	}

	_syncSquiggle(section) {
		const text = section.querySelector(".feature-section__heading-text");
		const squiggle = section.querySelector(".feature-section__squiggle");
		if (!text || !squiggle) return;

		if (window.innerWidth < 1024) {
			squiggle.style.width = text.getBoundingClientRect().width + "px";
		} else {
			squiggle.style.width = "";
		}
	}

	_setupParallax(section) {
		const img = section.querySelector("[data-feature-image]");
		if (!img) return;

		gsap.fromTo(
			img,
			{ y: 80 },
			{
				y: -80,
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: "top bottom",
					end: "bottom top",
					scrub: 0.8,
				},
			}
		);
	}
}

export default FeatureSection;
